import React, { FC } from 'react'
import { useBrand } from '../providers/brandProvider'

export const NewBrandingHoc = (LegacyComponent: FC<any>, DefaultComponent: FC<any>) => {
  const Component = (props: any) => {
    const brand = useBrand()
    if (brand === 'default') {
      return <DefaultComponent {...props} />
    }
    return <LegacyComponent {...props} />
  }
  return Component
}
